import i18n from '@/lang'
import formApi from '@/api/form'
import en from '@/lang/en'
import ru from '@/lang/ru'
import kz from '@/lang/kz'

export default {
  mounted(){
    formApi.getFormData().then(response => {
      let messages = {
        en,
        ru,
        kz,
      }

      let translations = response.data.form_translation.value

      for(let lang in translations){
        let newTranslation = messages[lang]
        newTranslation.form = {...newTranslation.form, ...translations[lang]}
        i18n.setLocaleMessage(lang, newTranslation)
      }
    })
  }
}